<template>
    <div id="CheckoutLogin" class="checkout-step" :class="{active: getCheckoutStep === 2}">
        <p class="heading">Login</p>
        <hr>
        <form class="wc-form holder" @submit.prevent="handleLogin()">
            <label for="login-email">Email</label>
            <input v-model.trim="$v.login.email.$model" name="Email" type="email" placeholder="Email" id="login-email" required/>
            <label for="login-password">Password</label>
            <input v-model.trim="$v.login.password.$model" name="Password" type="password" placeholder="Password" id="login-password" required/>
            <input class="btn btn-checkout shadow-light" type="submit" value="Login & Continue">

            <div class="for-errors" v-if="showErrors">
                <div class="error" v-if="!$v.login.email.required">Email is required.</div>
                <div class="error" v-if="!$v.login.email.email">Please use a valid email address.</div>
                <div class="error" v-if="!$v.login.password.required">Password is required.</div>
            </div>
        </form>
        <p class="heading">Guest Checkout</p>
        <hr>
        <div class="holder">
            <p class="guest-tip">First time? You can create an account during checkout for faster checkout next time!</p>
            <button class="btn btn-checkout shadow-light" @click="setCheckoutStep(3)">Continue as Guest</button>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    const {required, minLength, email, sameAs} = require('vuelidate/lib/validators');

    export default {
        name: "CheckoutLogin",
        data() {
            return {
                showErrors: false,
                login: {
                    email: '',
                    password: ''
                }
            }
        },
        validations: {
            login: {
                email: {required, email},
                password: {required}
            }
        },
        computed: {
            ...mapGetters(['getCheckoutStep'])
        },
        methods: {
            ...mapActions(['setCheckoutStep', 'loginShopUser']),
            handleLogin() {
                this.showErrors = true;
                let data = new FormData();
                data.append('Email', this.login.email);
                data.append('Password', this.login.password);
                this.loginShopUser(data);
            }
        }
    }
</script>

<style scoped>

</style>
